import React, { useState, useRef, useEffect } from "react";
// import $ from "jquery";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "jspdf-autotable";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { AxiosInstance } from "../../../../axios";
import { R_PER_PAGE } from "../../../../labels";
import { styled } from "@mui/material/styles";
import DatePickerSample from "../../DatePicker";
import Loader from "../../Loader";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import styles from "../StudentTestWorkflow/ClassPerformance.module.css";
import ViewBookSet from "../BookModule/BookModule.module.css";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";

function ClassList() {
  const moment = require("moment-timezone");
  const navigate = useNavigate();
  const { active_tab } = useParams();
  const location = useLocation();

  // Tab state management
  const [activeTab, setActiveTab] = useState(1);

  // Map tab index to event_type
  const tabEventTypeMap = {
    1: 0, // Course
    2: 1, // Test
    3: 2, // Counselling
    4: 3, // Special Class
    5: 5, // Mock Interview
  };

  // Tab configuration
  const tabs = [
    { id: 1, name: "Course", event_type: 0 },
    { id: 2, name: "Test", event_type: 1 },
    { id: 3, name: "Counselling", event_type: 2 },
    { id: 4, name: "Special Class", event_type: 3 },
    { id: 5, name: "Mock Interview", event_type: 5 },
  ];

  // Add this ref at the top to control API calls
  const skipApiCallRef = useRef(false);

  // Update tab based on URL parameter
  useEffect(() => {
    const tabIndex = Number(active_tab) || 1;
    setActiveTab(tabIndex);
    // Update eventType in appliedFilters instead of standalone state
    setAppliedFilters((prev) => ({
      ...prev,
      eventType: tabEventTypeMap[tabIndex] || 0,
    }));
  }, [active_tab]);

  // Handle tab click
  const handleTabClick = (index) => {
    // Clear all filters when switching tabs
    handleAllClear();

    // Update tab state
    setActiveTab(index);

    // Update filters with new eventType
    setAppliedFilters({
      searchTerm: "",
      status: [],
      course: [],
      subject: [],
      test_topics: [],
      categoryOn: [],
      appOn: [],
      eventType: tabEventTypeMap[index] || 0, // Set eventType here
      appData: {
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      },
    });

    // Navigate to new tab
    navigate(`/ClassList/${index}`);
  };

  // Refs for filter dropdowns
  const txtBSearch = useRef(null);
  const filterCategoryRef = useRef(null);
  const filterCourseRef = useRef(null);
  const filterSubjectRef = useRef(null);
  const filterTestTopicRef = useRef(null);
  const filterStartDateRef = useRef(null);
  const filterStatusRef = useRef(null);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);

  // List data load table
  let page = R_PER_PAGE;

  // State variables
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [csvData, setCsvData] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [isLoading, setIsLoading] = useState(false);
  const [dCourse, setDcourse] = useState([]);
  const [dCourses, setDcourses] = useState([]);
  const [ssubject, setSsubject] = useState([]);
  const [ssubjects, setSsubjects] = useState(ssubject);
  const [testTopic, setTestTopic] = useState([]);
  const [testTopics, setTestTopics] = useState(testTopic);
  const [ssubjectsFiltered, setSsubjectsFiltered] = useState(ssubjects);
  const [testTopicsFiltered, setTestTopicsFiltered] = useState(testTopics);
  const [updateListData, setUpdateListData] = useState([]);

  // APPLIED Filter state (what's actually sent to API) - eventType is included here
  const [appliedFilters, setAppliedFilters] = useState({
    searchTerm: "",
    status: [],
    course: [],
    subject: [],
    test_topics: [],
    categoryOn: [],
    appOn: [],
    eventType: 0, // eventType is now part of appliedFilters
    appData: {
      FDate: "",
      TDate: "",
      Days: "",
      name: "",
    },
  });

  // TEMPORARY Filter state (selections before applying)
  const [tempFilters, setTempFilters] = useState({
    status: [],
    course: [],
    subject: [],
    test_topics: [],
    categoryOn: [],
    appOn: [],
    appData: {
      FDate: "",
      TDate: "",
      Days: "",
      name: "",
    },
  });

  const [isOpen, setIsOpen] = useState({
    status: false,
    startDate: false,
    schedule: false,
    category: false,
    subject: false,
    classMode: false,
    course: false,
    testTopic: false,
  });

  const [updateChipData, setUpdateChipData] = useState([]);

  // Extract filter values for convenience
  const {
    searchTerm,
    status,
    course,
    subject,
    test_topics: testTopicsFilter,
    categoryOn,
    appOn,
    appData,
    eventType, // Now extracted from appliedFilters
  } = appliedFilters;

  // Scroll to top on data update
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [updateListData]);

  // In ClassList.js - Update the location state effect
  useEffect(() => {
    if (location.state) {
      const {
        filCategory,
        filCourse,
        filSubject,
        filTime,
        filTesttopic,
        filStatus,
        filSearch,
        filActiveTab,
        filEventType,
      } = location.state;

      // Skip the API call that would be triggered by setAppliedFilters
      skipApiCallRef.current = true;

      // Determine tab from event type or active tab
      const restoredEventType =
        filEventType || (filActiveTab ? tabEventTypeMap[filActiveTab] : 0);
      const tabId =
        filActiveTab ||
        Object.keys(tabEventTypeMap).find(
          (key) => tabEventTypeMap[key] === restoredEventType
        ) ||
        1;

      // Update ALL state in one go
      setAppliedFilters({
        searchTerm: filSearch || "",
        status: filStatus || [],
        course: filCourse || [],
        subject: filSubject || [],
        test_topics: filTesttopic || [],
        categoryOn: filCategory || [],
        appOn: filTime || [],
        eventType: restoredEventType,
        appData: {
          FDate: "",
          TDate: "",
          Days: "",
          name: "",
        },
      });

      // Update temp filters
      setTempFilters({
        status: filStatus || [],
        course: filCourse || [],
        subject: filSubject || [],
        test_topics: filTesttopic || [],
        categoryOn: filCategory || [],
        appOn: filTime || [],
        appData: {
          FDate: "",
          TDate: "",
          Days: "",
          name: "",
        },
      });

      // Update active tab
      setActiveTab(Number(tabId));

      // Navigate to update URL with tab
      navigate(`/ClassList/${tabId}`, { replace: true });

      // Re-enable API calls after state is updated
      setTimeout(() => {
        skipApiCallRef.current = false;
      }, 100);
    }
  }, [location.state]);

  // Update chip data when applied filters change
  useEffect(() => {
    loadChipdata();
  }, [appliedFilters]);

  // Initialize temp filters when dropdown opens
  useEffect(() => {
    const initializeTempFilters = () => {
      if (isOpen.category) {
        setTempFilters((prev) => ({
          ...prev,
          categoryOn: [...appliedFilters.categoryOn],
        }));
      }
      if (isOpen.course) {
        setTempFilters((prev) => ({
          ...prev,
          course: [...appliedFilters.course],
        }));
      }
      if (isOpen.subject) {
        setTempFilters((prev) => ({
          ...prev,
          subject: [...appliedFilters.subject],
        }));
      }
      if (isOpen.testTopic) {
        setTempFilters((prev) => ({
          ...prev,
          test_topics: [...appliedFilters.test_topics],
        }));
      }
      if (isOpen.status) {
        setTempFilters((prev) => ({
          ...prev,
          status: [...appliedFilters.status],
        }));
      }
      if (isOpen.startDate) {
        setTempFilters((prev) => ({
          ...prev,
          appOn: [...appliedFilters.appOn],
          appData: { ...appliedFilters.appData },
        }));
      }
    };

    if (Object.values(isOpen).some((val) => val === true)) {
      initializeTempFilters();
    }
  }, [isOpen]);

  // Outside click handler for filter dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterCategoryRef.current &&
        !filterCategoryRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, category: false }));
      }
      if (
        filterCourseRef.current &&
        !filterCourseRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, course: false }));
      }
      if (
        filterSubjectRef.current &&
        !filterSubjectRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, subject: false }));
      }
      if (
        filterTestTopicRef.current &&
        !filterTestTopicRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, testTopic: false }));
      }
      if (
        filterStartDateRef.current &&
        !filterStartDateRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, startDate: false }));
      }
      if (
        filterStatusRef.current &&
        !filterStatusRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, status: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Update filtered subjects and test topics
  useEffect(() => {
    setSsubjectsFiltered(ssubjects);
  }, [ssubjects]);

  useEffect(() => {
    setTestTopicsFiltered(testTopics);
  }, [testTopics]);

  // Sorting function
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };

  // Filter checkbox change handler - updates TEMP filters only
  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;

    if (typename === "type") {
      setTempFilters((prev) => {
        const currentCategory = prev.categoryOn || [];
        if (checked) {
          return {
            ...prev,
            categoryOn: [...currentCategory, { name: value, type: "type" }],
          };
        } else {
          return {
            ...prev,
            categoryOn: currentCategory.filter((item) => item.name !== value),
          };
        }
      });
    } else if (names === "course") {
      setTempFilters((prev) => {
        const currentCourse = prev.course || [];
        if (checked) {
          return {
            ...prev,
            course: [...currentCourse, { id: value, name, type: "course" }],
          };
        } else {
          return {
            ...prev,
            course: currentCourse.filter((item) => item.id !== value),
          };
        }
      });
    } else if (names === "subject") {
      setTempFilters((prev) => {
        const currentSubject = prev.subject || [];
        if (checked) {
          return {
            ...prev,
            subject: [
              ...currentSubject,
              { id: String(value), name, type: "subject" },
            ],
          };
        } else {
          return {
            ...prev,
            subject: currentSubject.filter((item) => item.id !== String(value)),
          };
        }
      });
    } else if (names === "test_topic") {
      setTempFilters((prev) => {
        const currentTestTopics = prev.test_topics || [];
        if (checked) {
          return {
            ...prev,
            test_topics: [
              ...currentTestTopics,
              { id: Number(value), name, type: "test_topic" },
            ],
          };
        } else {
          return {
            ...prev,
            test_topics: currentTestTopics.filter(
              (item) => item.id !== Number(value)
            ),
          };
        }
      });
    } else if (names === "status") {
      setTempFilters((prev) => {
        const currentStatus = prev.status || [];
        if (checked) {
          return {
            ...prev,
            status: [...currentStatus, { id: value, name, type: "status" }],
          };
        } else {
          return {
            ...prev,
            status: currentStatus.filter((item) => item.id !== value),
          };
        }
      });
    }
  };

  // Search handler - updates APPLIED filters immediately (no apply button for search)
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value.trim();
      setAppliedFilters((prev) => ({ ...prev, searchTerm: val }));
    }
  };

  // Search input change handler - updates local state only, not applied filters
  const handleSearchChange = (e) => {
    // Only update the search input value locally
    // Don't update appliedFilters here
    const val = e.target.value;

    // Update only the search input value in a separate state or use ref
    // We'll use a ref to store the current input value
    if (txtBSearch.current) {
      txtBSearch.current.value = val;
    }
  };

  // Search icon click handler - triggers search on click
  const handleSearchClick = () => {
    if (txtBSearch.current) {
      const val = txtBSearch.current.value.trim();
      setAppliedFilters((prev) => ({ ...prev, searchTerm: val }));
    }
  };

  // Search icon focus handler
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();
    }
  };

  // Filter search handlers
  const handleFilterCourseSearch = (event) => {
    const searchInput = event.target.value;
    if (searchInput != "") {
      const matchingObjects = dCourse.filter((item) =>
        item.toLowerCase().includes(searchInput.toLowerCase())
      );
      setDcourses(matchingObjects);
    } else {
      setDcourses(dCourse);
    }
  };

  const handleFilterSubjectSearch = (event) => {
    const searchInput = event.target.value;
    if (searchInput !== "") {
      const matchingObjects = ssubjects.filter((item) =>
        item.subject.toLowerCase().includes(searchInput.toLowerCase())
      );
      setSsubjectsFiltered(matchingObjects);
    } else {
      setSsubjectsFiltered(ssubjects);
    }
  };

  const handleFilterTestTopicSearch = (event) => {
    const searchInput = event.target.value;
    if (searchInput !== "") {
      const matchingObjects = testTopics.filter((item) =>
        item.test_topic.toLowerCase().includes(searchInput.toLowerCase())
      );
      setTestTopicsFiltered(matchingObjects);
    } else {
      setTestTopicsFiltered(testTopics);
    }
  };

  // Styled component for chips
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  // Clear all filters - preserve eventType when clearing
  // const handleAllClear = () => {
  //   setAppliedFilters((prev) => ({
  //     searchTerm: "",
  //     status: [],
  //     course: [],
  //     subject: [],
  //     test_topics: [],
  //     categoryOn: [],
  //     appOn: [],
  //     eventType: prev.eventType, // Keep current eventType when clearing filters
  //     appData: {
  //       FDate: "",
  //       TDate: "",
  //       Days: "",
  //       name: "",
  //     },
  //   }));
  //   setTempFilters({
  //     status: [],
  //     course: [],
  //     subject: [],
  //     test_topics: [],
  //     categoryOn: [],
  //     appOn: [],
  //     appData: {
  //       FDate: "",
  //       TDate: "",
  //       Days: "",
  //       name: "",
  //     },
  //   });
  //   setUpdateChipData([]);
  // };
  // Clear all filters - preserve eventType when clearing
  const handleAllClear = () => {
    setAppliedFilters((prev) => ({
      searchTerm: "",
      status: [],
      course: [],
      subject: [],
      test_topics: [],
      categoryOn: [],
      appOn: [],
      eventType: prev.eventType, // Keep current eventType when clearing filters
      appData: {
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      },
    }));

    // Also clear the input field
    if (txtBSearch.current) {
      txtBSearch.current.value = "";
    }

    setTempFilters({
      status: [],
      course: [],
      subject: [],
      test_topics: [],
      categoryOn: [],
      appOn: [],
      appData: {
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      },
    });
    setUpdateChipData([]);
  };

  // Apply filter handler - moves temp filters to applied filters
  const handleApplyFilter = (name) => {
    if (name === "type") {
      setAppliedFilters((prev) => ({
        ...prev,
        categoryOn: [...tempFilters.categoryOn],
      }));
    } else if (name === "course") {
      setAppliedFilters((prev) => ({
        ...prev,
        course: [...tempFilters.course],
      }));
    } else if (name === "subject") {
      setAppliedFilters((prev) => ({
        ...prev,
        subject: [...tempFilters.subject],
      }));
    } else if (name === "test_topic") {
      setAppliedFilters((prev) => ({
        ...prev,
        test_topics: [...tempFilters.test_topics],
      }));
    } else if (name === "status") {
      setAppliedFilters((prev) => ({
        ...prev,
        status: [...tempFilters.status],
      }));
    } else if (name === "appliedOn") {
      setAppliedFilters((prev) => ({
        ...prev,
        appOn: [...tempFilters.appOn],
        appData: { ...tempFilters.appData },
      }));
    }

    // Close the filter dropdown
    setIsOpen({
      ...isOpen,
      [name === "appliedOn" ? "startDate" : name]: false,
    });
  };

  // Load list data from API using APPLIED filters
  function loadListdata() {
    let tempstatus = [];
    let temptypeon = [];
    let tempCourses = [];
    let tempMedium = [];
    let tempTestTopic = [];

    // Status
    if (Array.isArray(appliedFilters.status)) {
      tempstatus = appliedFilters.status
        .map((obj) => Number(obj.id))
        .filter((id) => !isNaN(id));
    }

    // Courses
    if (Array.isArray(appliedFilters.course)) {
      tempCourses = appliedFilters.course
        .map((obj) => obj?.name || obj?.category_class)
        .filter((cls) => cls && cls.trim() !== "");
    }

    // Mediums
    if (Array.isArray(appliedFilters.subject)) {
      tempMedium = appliedFilters.subject
        .map((obj) => obj?.id)
        .filter((id) => id !== null && id !== undefined);
    }

    // Test Topics
    if (Array.isArray(appliedFilters.test_topics)) {
      tempTestTopic = appliedFilters.test_topics
        .map((obj) => obj?.id)
        .filter((id) => id !== null && id !== undefined);
    }

    // Type
    if (Array.isArray(appliedFilters.categoryOn)) {
      temptypeon = appliedFilters.categoryOn
        .map((obj) => obj?.name)
        .filter((name) => name && name.trim() !== "");
    }

    // Convert to numbers where needed
    const tempLocMedium = tempMedium.map(Number).filter((n) => !isNaN(n));
    const tempLocTestTopic = tempTestTopic.map(Number).filter((n) => !isNaN(n));

    // Build payload with event_type from appliedFilters
    let statusFilter = {
      category: temptypeon.length > 0 ? temptypeon : "",
      course: tempCourses.length > 0 ? tempCourses : "",
      status: tempstatus.length > 0 ? tempstatus : "",
      start_date:
        appliedFilters.appOn.length > 0 && appliedFilters.appOn[0].fdate
          ? appliedFilters.appOn[0].fdate + " 00:00:00"
          : "",
      end_date:
        appliedFilters.appOn.length > 0 && appliedFilters.appOn[0].edate
          ? appliedFilters.appOn[0].edate + " 23:59:00"
          : "",
      search:
        appliedFilters.searchTerm.length > 0 ? appliedFilters.searchTerm : "",
      subject: tempLocMedium.length > 0 ? tempLocMedium : "",
      test_topic: tempLocTestTopic.length > 0 ? tempLocTestTopic : "",
      qu_start_date: "",
      qu_end_date: "",
      method_of_test: "",
      type: appliedFilters.eventType, // Use from appliedFilters
      section: "",
      location: "",
      class_mode: "",
      staff_id: "",
      staff_name: "",
      page_no: "",
      page_size: "",
    };

    setIsLoading(true);

    AxiosInstance.post("api/test/report/list/byAdmin", statusFilter)
      .then((res) => {
        setIsLoading(false);

        if (res.data.status === true) {
          setCurrentPage(1);
          const fiata = res.data.data;

          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));

          const statusMap = {
            0: "Upcoming",
            1: "Ongoing",
            2: "Answer Not Yet Uploaded",
            3: "Completed",
          };

          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            batch_name: item.batch_name,
            category: item.category,
            category_class: item.category_class,
            event_name: item.event_name,
            subject: item.subject?.map((s) => s.subject).join(", ") ?? "",
            test_topic:
              item.test_topic?.map((t) => t.test_topic).join(", ") ?? "",
            start_date: moment(item.start_date).format("DD/MM/YYYY"),
            start_time: item.start_time,
            status: statusMap[item.que_status] ?? "Completed",
          }));

          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);

          // Unique classes (courses)
          const uniqueClasses = [
            ...new Set(fiata.map((item) => item.category_class)),
          ];
          setDcourse(uniqueClasses);
          setDcourses(uniqueClasses);

          // Unique subjects
          const subjectSet = fiata.flatMap((event) => event.subject || []);
          const uniqueSubjectMap = new Map();
          subjectSet.forEach((subj) => {
            if (subj?.subject) {
              uniqueSubjectMap.set(subj.subject.toLowerCase(), subj);
            }
          });
          const uniqueSubjects = Array.from(uniqueSubjectMap.values());
          setSsubject(uniqueSubjects);
          setSsubjects(uniqueSubjects);

          // Unique test topics
          const testtopicSet = fiata.flatMap((event) => event.test_topic || []);
          const uniqueTestTopicMap = new Map();
          testtopicSet.forEach((topic) => {
            if (topic?.test_topic) {
              uniqueTestTopicMap.set(topic.test_topic.toLowerCase(), topic);
            }
          });
          const uniqueTestTopics = Array.from(uniqueTestTopicMap.values());
          setTestTopic(uniqueTestTopics);
          setTestTopics(uniqueTestTopics);
        } else {
          setUpdateListData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setUpdateListData([]);
        console.error("Error loading list data:", error);
      });
  }

  // Effect to trigger API call when applied filters change
  useEffect(() => {
    // Skip initial mount API call
    if (skipApiCallRef.current) {
      skipApiCallRef.current = false;
      return;
    }

    loadListdata();
  }, [appliedFilters]); // Just one dependency now

  // Load chip data from APPLIED filters
  function loadChipdata() {
    let tempArr = [];

    // Add search chip
    if (appliedFilters.searchTerm.length > 0) {
      tempArr.push({ name: appliedFilters.searchTerm, type: "search" });
    }

    // Add category chips
    appliedFilters.categoryOn.forEach((obj) => {
      tempArr.push(obj);
    });

    // Add status chips
    appliedFilters.status.forEach((obj) => {
      tempArr.push(obj);
    });

    // Add course chips
    appliedFilters.course.forEach((obj) => {
      tempArr.push(obj);
    });

    // Add date chips
    appliedFilters.appOn.forEach((obj) => {
      tempArr.push(obj);
    });

    // Add subject chips
    appliedFilters.subject.forEach((obj) => {
      tempArr.push(obj);
    });

    // Add test topic chips
    appliedFilters.test_topics.forEach((obj) => {
      tempArr.push(obj);
    });

    setUpdateChipData(tempArr);
  }

  // Clear specific filter - resets both temp and applied filters
  const handleClear = (name) => {
    if (name === "appliedOn") {
      setAppliedFilters((prev) => ({
        ...prev,
        appOn: [],
        appData: {
          FDate: "",
          TDate: "",
          Days: "",
          name: "",
        },
      }));
      setTempFilters((prev) => ({
        ...prev,
        appOn: [],
        appData: {
          FDate: "",
          TDate: "",
          Days: "",
          name: "",
        },
      }));
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "status") {
      setAppliedFilters((prev) => ({
        ...prev,
        status: [],
      }));
      setTempFilters((prev) => ({
        ...prev,
        status: [],
      }));
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "type") {
      setAppliedFilters((prev) => ({
        ...prev,
        categoryOn: [],
      }));
      setTempFilters((prev) => ({
        ...prev,
        categoryOn: [],
      }));
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "subject") {
      setAppliedFilters((prev) => ({
        ...prev,
        subject: [],
      }));
      setTempFilters((prev) => ({
        ...prev,
        subject: [],
      }));
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "test_topic") {
      setAppliedFilters((prev) => ({
        ...prev,
        test_topics: [],
      }));
      setTempFilters((prev) => ({
        ...prev,
        test_topics: [],
      }));
      setIsOpen({
        ...isOpen,
        testTopic: false,
      });
    } else if (name === "course") {
      setAppliedFilters((prev) => ({
        ...prev,
        course: [],
      }));
      setTempFilters((prev) => ({
        ...prev,
        course: [],
      }));
      setIsOpen({
        ...isOpen,
        course: false,
      });
    }
  };

  // Delete chip handler - removes from APPLIED filters
  // const handleDelete = (chipToDelete, index) => () => {
  //   if (chipToDelete.type === "search") {
  //     setAppliedFilters((prev) => ({ ...prev, searchTerm: "" }));
  //   } else if (chipToDelete.type === "status") {
  //     setAppliedFilters((prev) => ({
  //       ...prev,
  //       status: prev.status.filter((item) => item.id !== chipToDelete.id),
  //     }));
  //   } else if (chipToDelete.type === "course") {
  //     setAppliedFilters((prev) => ({
  //       ...prev,
  //       course: prev.course.filter((item) => item.id !== chipToDelete.id),
  //     }));
  //   } else if (chipToDelete.type === "subject") {
  //     setAppliedFilters((prev) => ({
  //       ...prev,
  //       subject: prev.subject.filter((item) => item.id !== chipToDelete.id),
  //     }));
  //   } else if (chipToDelete.type === "type") {
  //     setAppliedFilters((prev) => ({
  //       ...prev,
  //       categoryOn: prev.categoryOn.filter(
  //         (item) => item.name !== chipToDelete.name
  //       ),
  //     }));
  //   } else if (chipToDelete.type === "dateRange") {
  //     setAppliedFilters((prev) => ({
  //       ...prev,
  //       appOn: [],
  //       appData: {
  //         FDate: "",
  //         TDate: "",
  //         Days: "",
  //         name: "",
  //       },
  //     }));
  //   } else if (chipToDelete.type === "test_topic") {
  //     setAppliedFilters((prev) => ({
  //       ...prev,
  //       test_topics: prev.test_topics.filter(
  //         (item) => item.id !== chipToDelete.id
  //       ),
  //     }));
  //   }
  // };
  // Delete chip handler - removes from APPLIED filters
  const handleDelete = (chipToDelete, index) => () => {
    if (chipToDelete.type === "search") {
      setAppliedFilters((prev) => ({ ...prev, searchTerm: "" }));
      // Also clear the input field
      if (txtBSearch.current) {
        txtBSearch.current.value = "";
      }
    } else if (chipToDelete.type === "status") {
      setAppliedFilters((prev) => ({
        ...prev,
        status: prev.status.filter((item) => item.id !== chipToDelete.id),
      }));
    } else if (chipToDelete.type === "course") {
      setAppliedFilters((prev) => ({
        ...prev,
        course: prev.course.filter((item) => item.id !== chipToDelete.id),
      }));
    } else if (chipToDelete.type === "subject") {
      setAppliedFilters((prev) => ({
        ...prev,
        subject: prev.subject.filter((item) => item.id !== chipToDelete.id),
      }));
    } else if (chipToDelete.type === "type") {
      setAppliedFilters((prev) => ({
        ...prev,
        categoryOn: prev.categoryOn.filter(
          (item) => item.name !== chipToDelete.name
        ),
      }));
    } else if (chipToDelete.type === "dateRange") {
      setAppliedFilters((prev) => ({
        ...prev,
        appOn: [],
        appData: {
          FDate: "",
          TDate: "",
          Days: "",
          name: "",
        },
      }));
    } else if (chipToDelete.type === "test_topic") {
      setAppliedFilters((prev) => ({
        ...prev,
        test_topics: prev.test_topics.filter(
          (item) => item.id !== chipToDelete.id
        ),
      }));
    }
  };

  // Date change handler - updates TEMP filters only
  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      setTempFilters((prev) => {
        const updatedAppData = {
          ...prev.appData,
          [name]: dateFilter,
          Days: "",
        };

        const from = name === "FDate" ? dateFilter : updatedAppData.FDate;
        const to = name === "TDate" ? dateFilter : updatedAppData.TDate;

        let newAppOn = [];
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          newAppOn = [
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ];
        }

        return {
          ...prev,
          appData: updatedAppData,
          appOn: newAppOn,
        };
      });
    }
  };

  // Filter toggle handler
  const handleFilter = (e, boxName) => {
    setIsOpen((prevState) => {
      const newState = {
        startDate: false,
        schedule: false,
        category: false,
        subject: false,
        classMode: false,
        status: false,
        course: false,
        testTopic: false,
      };
      newState[boxName] = !prevState[boxName];
      return newState;
    });
  };

  // Generate PDF
  const generatePDF = () => {
    const headers = [
      "S.No",
      "Batch Name",
      "Category",
      "Course",
      "Class Name",
      "Subject",
      "Class Topic",
      "Test Date",
      "Test Time",
      "Status",
    ];

    const rows = csvData.map((item, index) => [
      index + 1,
      item.batch_name ?? "-",
      item.category ?? "-",
      item.category_class ?? "-",
      item.event_name ?? "-",
      item.subject ?? "-",
      item.test_topic ?? "-",
      item.start_date ?? "-",
      item.start_time ?? "-",
      item.status ?? "-",
    ]);
    navigate("/preview", {
      state: {
        title: "Class List Data",
        headers,
        rows,
        filename: "ClassList.pdf",
        autoPrint: true,
      },
    });
  };

  // Pagination
  const totalPages = Math.ceil(updateListData.length / rowsPerPage);
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);

  // Read view handler - sends APPLIED filter state
  const handleReadView = (id, type, typeStatus,eventType) => {
    navigate(`/DetailTestView/${id}/${type}/${typeStatus}`, {
      state: {
        CATEGORY: appliedFilters.categoryOn,
        COURSE: appliedFilters.course,
        SUBJECT: appliedFilters.subject,
        TIME: appliedFilters.appOn,
        TESTTOPIC: appliedFilters.test_topics,
        STATUS: appliedFilters.status,
        EVENTTYPE:eventType,
        SEARCHTERM: appliedFilters.searchTerm,
        ACTIVE_TAB: activeTab,
    
      },
    });
  };

  // CSV headers
  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Batch Name", key: "batch_name" },
    { label: "Category", key: "category" },
    { label: "Course", key: "category_class" },
    { label: "Class Name", key: "event_name" },
    { label: "Subject", key: "subject" },
    { label: "Class Topic", key: "test_topic" },
    { label: "Class Date", key: "start_date" },
    { label: "Class Time", key: "start_time" },
    { label: "Status", key: "status" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className="BathDet global_container px-3">
      {/* Tab Navigation */}
      <div className="row">
        <div className="col-md-12">
          <ul
            className="nav cm_nav-fill mb-3"
            id="cm_listViewTabs"
            role="tablist"
          >
            {tabs.map((tab) => (
              <li className="nav-item" role="presentation" key={tab.id}>
                <a
                  className={
                    activeTab === tab.id ? "nav-link active" : "nav-link"
                  }
                  href="javascript:void(0)"
                  role="tab"
                  aria-selected={activeTab === tab.id}
                  onClick={() => handleTabClick(tab.id)}
                >
                  {tab.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <h6 className="Title">Class</h6>
      <div className="row ">
        <div className="col-lg-5 col-md-12">
          <div className="input-group">
            <input
              style={{ width: "50%" }}
              ref={txtBSearch}
              type="text"
              className="Inputs"
              id="SearchInput"
              name="SearchInput"
              placeholder="Search by Class Name, Batch Name"
              onKeyDown={handleSearch}
              defaultValue={appliedFilters.searchTerm}
              onChange={handleSearchChange}
            />
            <span
              className="input-group-text"
              id="SearchInput"
              onClick={handleSearchFocus}
            >
              <span className="material-icons" onClick={handleSearchFocus}>
                search
              </span>
            </span>
          </div>
        </div>
        <div className="col-md-7">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <CustomDownloadButton
                csvListData={csvData?.length > 0 ? csvData : ""}
                headers={csvHeaders}
                iconName=" file_download "
                filename={"Classlist.csv"}
                csvName="  Download as CSV"
              />
            </li>
            <li className="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
          </ul>
        </div>
      </div>
      {updateChipData.length > 0 ? (
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-xs-12 " id="paperil">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData.map((data, index) => {
                let key = "" + data.name;
                return (
                  <ListItem key={index}>
                    <Chip label={key} onDelete={handleDelete(data, index)} />
                  </ListItem>
                );
              })}
              <ListItem className="clearAll_list">
                <a
                  className={"clearAll_listItem"}
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      <div className="row mt-4 m-0">
        <div className="col-md-12 table-responsive p-0  tableMinHeight p-0">
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                {/* S.No */}
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    S.No
                  </span>
                  <span
                    className="textHead_th material-icons align-middle"
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    import_export
                  </span>
                </th>
                {/* Batch name */}
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "batch_name")}
                  >
                    Batch Name
                  </span>
                  <span
                    className="textHead_th material-icons align-middle"
                    onClick={(e) => handleSort(e, "batch_name")}
                  >
                    import_export
                  </span>
                </th>
                {/* Category */}
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "category")}
                  >
                    {" "}
                    Category
                  </span>{" "}
                  <span
                    className="material-icons align-middle"
                    onClick={(e) => handleSort(e, "category")}
                  >
                    {" "}
                    import_export{" "}
                  </span>{" "}
                  <span
                    className={` align-middle material-icons  ${
                      appliedFilters.categoryOn.length > 0 || isOpen.category
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "category")}
                  >
                    filter_list
                  </span>
                  {isOpen.category === true && (
                    <div
                      className="filterBoxs_testlist p-1"
                      ref={filterCategoryRef}
                    >
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div className="form-check">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="UPSC"
                              value="UPSC"
                              id="UPSC"
                              checked={tempFilters.categoryOn.some(
                                (element) => {
                                  if (element.name === "UPSC") {
                                    return true;
                                  }
                                  return false;
                                }
                              )}
                              onChange={(e) =>
                                handleCheckboxChange(e, "UPSC", "type")
                              }
                            />
                            <label className="form-check-label " htmlFor="UPSC">
                              UPSC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="form-check">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="TNPSC"
                              value="TNPSC"
                              id="TNPSC"
                              checked={tempFilters.categoryOn.some(
                                (element) => {
                                  if (element.name === "TNPSC") {
                                    return true;
                                  }
                                  return false;
                                }
                              )}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TNPSC", "type")
                              }
                            />
                            <label
                              className="form-check-label "
                              htmlFor="TNPSC"
                            >
                              TNPSC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="form-check">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="RRB"
                              value="RRB"
                              id="RRB"
                              checked={tempFilters.categoryOn.some(
                                (element) => {
                                  if (element.name === "RRB") {
                                    return true;
                                  }
                                  return false;
                                }
                              )}
                              onChange={(e) =>
                                handleCheckboxChange(e, "RRB", "type")
                              }
                            />
                            <label className="form-check-label " htmlFor="RRB">
                              RRB
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="form-check">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="TET"
                              value="TET"
                              id="TET"
                              checked={tempFilters.categoryOn.some(
                                (element) => {
                                  if (element.name === "TET") {
                                    return true;
                                  }
                                  return false;
                                }
                              )}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TET", "type")
                              }
                            />
                            <label className="form-check-label " htmlFor="TET">
                              TET
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="form-check">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="TRB"
                              value="TRB"
                              id="TRB"
                              checked={tempFilters.categoryOn.some(
                                (element) => {
                                  if (element.name === "TRB") {
                                    return true;
                                  }
                                  return false;
                                }
                              )}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TRB", "type")
                              }
                            />
                            <label className="form-check-label " htmlFor="TRB">
                              TRB
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="form-check">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="TNUSRB"
                              value="TNUSRB"
                              id="TNUSRB"
                              checked={tempFilters.categoryOn.some(
                                (element) => {
                                  if (element.name === "TNUSRB") {
                                    return true;
                                  }
                                  return false;
                                }
                              )}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TNUSRB", "type")
                              }
                            />
                            <label
                              className="form-check-label "
                              htmlFor="TNUSRB"
                            >
                              TNUSRB
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="form-check">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="SSC"
                              value="SSC"
                              id="SSC"
                              checked={tempFilters.categoryOn.some(
                                (element) => {
                                  if (element.name === "SSC") {
                                    return true;
                                  }
                                  return false;
                                }
                              )}
                              onChange={(e) =>
                                handleCheckboxChange(e, "SSC", "type")
                              }
                            />
                            <label className="form-check-label " htmlFor="SSC">
                              SSC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="form-check">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="Banking"
                              value="Banking"
                              checked={tempFilters.categoryOn.some(
                                (element) => {
                                  if (element.name === "Banking") {
                                    return true;
                                  }
                                  return false;
                                }
                              )}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Banking", "type")
                              }
                              id="Banking"
                            />
                            <label
                              className="form-check-label "
                              htmlFor="Banking"
                            >
                              Banking
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("type")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleApplyFilter("type")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                {/* Course */}
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "category_class")}
                  >
                    Course
                  </span>

                  <span className="material-icons align-middle">
                    import_export
                  </span>

                  <span
                    className={`align-middle material-icons ${
                      appliedFilters.course.length > 0 || isOpen.course
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "course")}
                  >
                    filter_list
                  </span>

                  {isOpen.course === true && (
                    <div
                      className="filterBoxs_testlist p-1"
                      ref={filterCourseRef}
                    >
                      <div className="filterBoxText">
                        <div className="row ms-1">
                          <div className="col-lg-12 col-md-12">
                            <div className="input-group searchInputsss">
                              <input
                                type="text"
                                className="Inputs"
                                id="SearchFilterInputs"
                                name="SearchFilterInputs"
                                placeholder="Search Here"
                                onKeyDown={handleFilterCourseSearch}
                              />
                              <span
                                className="input-group-text"
                                id="SearchInput"
                              >
                                <span className="material-icons">search</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <hr />

                        {dCourses.map((el) => (
                          <div className="row mt-2" key={el}>
                            <div className="col-md-12">
                              <div className="form-check">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el}
                                  value={el}
                                  id={el}
                                  checked={tempFilters.course.some(
                                    (element) => element.name === el
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "course")
                                  }
                                />
                                <label
                                  className="form-check-label PinkText"
                                  htmlFor={el}
                                >
                                  {el}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("course")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleApplyFilter("course")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                {/* Class Name */}
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "event_name")}
                  >
                    {" "}
                    Class Name
                  </span>
                  <span
                    className="material-icons align-middle"
                    onClick={(e) => handleSort(e, "event_name")}
                  >
                    import_export
                  </span>{" "}
                </th>
                {/* Subject */}
                <th id="th">
                  <span className="text_th"> Subject</span>{" "}
                  <span
                    className={` align-middle material-icons  ${
                      appliedFilters.subject.length > 0 || isOpen.subject
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "subject")}
                  >
                    filter_list
                  </span>
                  {isOpen.subject === true && (
                    <div
                      className="filterBoxs_testlist p-1"
                      ref={filterSubjectRef}
                    >
                      <div className="filterBoxText ">
                        <div className="row ms-1">
                          <div className="col-lg-12 col-md-12">
                            <div className="input-group searchInputsss">
                              <input
                                type="text"
                                className="Inputs"
                                id="SearchFilterInputs"
                                placeholder="Search Here"
                                onChange={handleFilterSubjectSearch}
                              />
                              <span
                                className="input-group-text"
                                id="SearchInput"
                              >
                                <span className="material-icons">search</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <hr />
                        {ssubjectsFiltered.map((el) => (
                          <div className="row mt-2" key={el.subject_pk}>
                            <div className="col-md-12">
                              <div className="form-check">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.subject}
                                  value={el.subject_pk}
                                  id={el.subject}
                                  checked={tempFilters.subject.some(
                                    (element) =>
                                      element.id === String(el.subject_pk)
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "subject")
                                  }
                                />
                                <label
                                  className="form-check-label PinkText"
                                  htmlFor={el.subject}
                                >
                                  {el.subject}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("subject")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleApplyFilter("subject")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                {/* Test Topic */}
                <th id="th">
                  <span className="text_th"> Class Topic</span>{" "}
                  <span
                    className={` align-middle material-icons  ${
                      appliedFilters.test_topics.length > 0 || isOpen.testTopic
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "testTopic")}
                  >
                    filter_list
                  </span>
                  {isOpen.testTopic === true && (
                    <div
                      className="filterBoxs_testlist p-1"
                      ref={filterTestTopicRef}
                    >
                      <div className="filterBoxText">
                        <div className="row ms-1">
                          <div className="col-lg-12 col-md-12">
                            <div className="input-group searchInputsss">
                              <input
                                type="text"
                                className="Inputs"
                                id="SearchFilterInputs"
                                placeholder="Search Here"
                                onChange={handleFilterTestTopicSearch}
                              />
                              <span
                                className="input-group-text"
                                id="SearchInput"
                              >
                                <span className="material-icons">search</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <hr />
                        {testTopicsFiltered.map((el) => (
                          <div className="row mt-2" key={el.test_topic_pk}>
                            <div className="col-md-12">
                              <div className="form-check">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.test_topic}
                                  value={el.test_topic_pk}
                                  id={el.test_topic}
                                  checked={tempFilters.test_topics.some(
                                    (element) => element.id === el.test_topic_pk
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "test_topic")
                                  }
                                />
                                <label
                                  className="form-check-label PinkText"
                                  htmlFor={el.test_topic}
                                >
                                  {el.test_topic}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("test_topic")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleApplyFilter("test_topic")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                {/* Class Date and time */}
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "start_date")}
                  >
                    Class Date & Time
                  </span>{" "}
                  <span
                    className="material-icons align-middle"
                    onClick={(e) => handleSort(e, "start_date")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "startDate")}
                    className={` align-middle material-icons  ${
                      appliedFilters.appOn.length > 0 || isOpen.startDate
                        ? styles.active_icons_book
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.startDate === true && (
                    <div
                      className="filterBoxOne_Con container  p-1"
                      ref={filterStartDateRef}
                    >
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div className="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              className={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate}
                              fieldInput={tempFilters.appData.FDate}
                              txtAdMDob={fDatePickerRef}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div className="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <DatePickerSample
                              className={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate}
                              fieldInput={tempFilters.appData.TDate}
                              txtAdMDob={tDatePickerRef}
                              minDate={tempFilters.appData.FDate}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("appliedOn")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleApplyFilter("appliedOn")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                {/* Status */}
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "status")}
                  >
                    Status
                  </span>
                  <span
                    className="textHead_th material-icons align-middle"
                    onClick={(e) => handleSort(e, "status")}
                  >
                    import_export
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${
                      appliedFilters.status.length > 0
                        ? styles.active_icons
                        : ""
                    } ${isOpen.status ? styles.active_icons : ""}`}
                    onClick={(e) => handleFilter(e, "status")}
                  >
                    filter_list
                  </span>
                  {isOpen.status === true && (
                    <div className="filterBoxs_testlist" ref={filterStatusRef}>
                      <div className="col-md-12 form-check filterStatus_list">
                        <ul className="ulFilterListData">
                          {/* Completed */}
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"Completed"}
                              value={"3"}
                              checked={tempFilters.status.some((element) => {
                                if (element.id == "3") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"Completed"}
                              onChange={(e) =>
                                handleCheckboxChange(e, "status", "status")
                              }
                            />
                            <label
                              className="form-check-label filterChipText bg-danger"
                              htmlFor={"Completed"}
                            >
                              Completed
                            </label>
                          </li>
                          {/* Attendence */}
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"Attendence not yet Uploaded"}
                              value={"2"}
                              checked={tempFilters.status.some((element) => {
                                if (element.id == "2") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"Attendence not yet Uploaded"}
                              onChange={(e) =>
                                handleCheckboxChange(e, "status", "status")
                              }
                            />
                            <label
                              className="form-check-label bg-secondary filterChipText"
                              htmlFor={"Attendence not yet Uploaded"}
                            >
                              Attendence not yet Uploaded
                            </label>
                          </li>
                          {/* Ongoing */}
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"Ongoing"}
                              value={"1"}
                              checked={tempFilters.status.some((element) => {
                                if (element.id == "1") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"Ongoing"}
                              onChange={(e) =>
                                handleCheckboxChange(e, "status", "status")
                              }
                            />
                            <label
                              className="form-check-label filterChipText bg-green"
                              htmlFor={"Ongoing"}
                            >
                              Ongoing
                            </label>
                          </li>
                          {/* Upcoming */}
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"Upcoming"}
                              value={"0"}
                              checked={tempFilters.status.some((element) => {
                                if (element.id == "0") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"Upcoming"}
                              onChange={(e) =>
                                handleCheckboxChange(e, "status", "status")
                              }
                            />
                            <label
                              className="form-check-label bg-orange filterChipText  "
                              htmlFor={"Upcoming"}
                            >
                              Upcoming
                            </label>
                          </li>
                        </ul>
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("status")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleApplyFilter("status")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>

                <th id="th">
                  {" "}
                  <span className="text_th">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center" }}>
                    No record to display
                  </td>
                </tr>
              ) : (
                currentData.map((course, index) => (
                  <tr key={index} title={course.pk}>
                    <td id="td">{course.serialNumber}</td>
                    <td id="td">
                      <span
                        title={course.batch_name}
                        className={styles.ellipsisText}
                      >
                        {course.batch_name || "_"}
                      </span>
                    </td>
                    <td id="td">
                      <span
                        title={course.category}
                        className={styles.ellipsisText}
                      >
                        {course.category || "_"}
                      </span>
                    </td>
                    <td id="td">
                      <span
                        title={course.category_class}
                        className={styles.ellipsisText}
                      >
                        {course.category_class || "_"}
                      </span>
                    </td>
                    <td id="td">
                      <span
                        title={course.event_name}
                        className={styles.ellipsisText}
                      >
                        {course.event_name || "_"}
                      </span>
                    </td>
                    <td id="td">
                      <span
                        title={course.subject}
                        className={styles.ellipsisText}
                      >
                        {course.subject && course.subject.length > 0
                          ? course.subject
                              .map((subject) => subject.subject)
                              .join(", ")
                          : "_"}
                      </span>
                    </td>
                    <td id="td">
                      <span
                        title={
                          course.test_topic && course.test_topic.length > 0
                            ? course.test_topic
                                .map((item) => item.test_topic)
                                .join(", ")
                            : "_"
                        }
                        className={styles.ellipsisText}
                      >
                        {course.test_topic && course.test_topic.length > 0
                          ? course.test_topic
                              .map((item) => item.test_topic)
                              .join(", ")
                          : "_"}
                      </span>
                    </td>
                    <td id="td">
                      <span>
                        {" "}
                        {moment(course.start_date).format("DD/MM/YYYY")}
                      </span>
                      <span> {course.start_time}</span>
                    </td>
                    {course.que_status === 0 && (
                      <td id="td">
                        <span className="filterChipText bg-orange mx-0">
                          Upcoming
                        </span>
                      </td>
                    )}
                    {course.que_status === 1 && (
                      <td id="td">
                        <span className="filterChipText bg-green mx-0">
                          Ongoing
                        </span>
                      </td>
                    )}

                    {course.que_status === 2 && (
                      <td id="td">
                        <span className="filterChipText bg-secondary mx-0">
                          Attendence not yet Uploaded
                        </span>
                      </td>
                    )}

                    {course.que_status === 3 && (
                      <td id="td">
                        <span className="filterChipText bg-danger mx-0">
                          Completed
                        </span>
                      </td>
                    )}
                    <td id="td">
                      <button
                        className={"view_icon_button"}
                        onClick={() =>
                          handleReadView(
                            course.event_pk,
                            course.type,
                            course.que_status,
                            course.event_type 
                          )
                        }
                      >
                        <span className={`visibleicon material-icons`}>
                          visibility
                        </span>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={
            updateListData && updateListData?.length > 0
              ? currentPage * rowsPerPage + 1 - rowsPerPage
              : 0
          }
          endPage={
            updateListData && updateListData?.length > 0
              ? updateListData?.length < currentPage * rowsPerPage
                ? updateListData?.length
                : currentPage * rowsPerPage
              : 0
          }
          totalRecords={
            updateListData && updateListData?.length > 0
              ? updateListData?.length
              : 0
          }
          handlePrev={(e) => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${ViewBookSet.prev_buttonViewAllbook} ${ViewBookSet.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={totalPages == 0 || currentPage === totalPages}
        />
      </div>
    </div>
  );
}

export default ClassList;
